module.exports = __webpack_public_path__ + "img/new_entertainment.f03baa74.svg";